import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { clientGetVendor } from "@services/vendors.service";
import { getValue } from "@utils/lodash";
import Notfound from "@components/Not-Found-small";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import {
  clientGetLocation,
  clientGetLocationAttachedVendorNew,
} from "@services/location.service";
import Loader from "@components/common/Loader";
import { NavLink } from "react-router-dom";
import { months } from "@_common/month";
import { years } from "@_common/year";
import InputField from "@_common/InputRuleFeild";
import { assignCheckpointReleaseVendor } from "@services/checkpoint.service";
import _ from "lodash";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import PaginationPage from "@components/pagination/pagination";
import StringSearch from "@components/common/StringSearch";
import { allParams } from "@_common/common-helper";
export default function CheckPointReleaseVendor(props: any) {
  let params = useParams();
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [activeTab, setActiveTab] = useState(1);
  const [locationList, setLocationList] = useState([]);
  const [vendorsList, setVendorsList] = useState([]);
  const [subVendorList, setSubVendorList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(true);
  const [isLoading2, setIsLoading2] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [month, setMonth] = useState<string | number | any>("");
  const [year, setYear] = useState<string | number | any>("");

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    var date = new Date();
    if (props.permissionAPITriggered) {
      getLocations(location_page_no, search_text);
    }
    // getVendorList();
    setMonth(date.getMonth() + 2);
    setYear(date.getFullYear());
  }, [props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const [selectedItems, setSelectedItems] = useState<any>({});

  const [location_page_no, setLocationPageNo] = useState<any>(1);
  const [location_page_limit, setLocationPageLimit] = useState(10);
  const [location_total_count, setLocationTotalCount] = useState(0);

  const handleLocationPagination = (page_no: string) => {
    setLocationPageNo(page_no);
    getLocations(page_no, search_text);
    setSubVendorPageNo(1);
    setVendorPageNo(1);
  };
  const getLocations = async (page_no: any, search_text: string) => {
    try {
      let payload: any = {
        page_no: page_no,
        page_size: location_page_limit,
        // is_active: true,
        search_text: search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        let filtered = getValue(
          resp,
          `data.locations`,
          []
        ).filter((item: object) => getValue(item, `is_active`, false));

        setLocationList(
          getValue(filtered, `length`, 0) > 0 &&
            filtered.map((item: object) => ({
              ...item,
              status: getValue(item, `is_active`, false)
                ? "Active"
                : "Inactive",
              city_name: getValue(item, `city.name`, ""),
              value: getValue(item, `location_name`, ""),
              label: getValue(item, `location_name`, ""),
            }))
        );
        setLocationTotalCount(getValue(resp, `data.pagination.total`, 0));
        getVendorList(getValue(filtered, `[${0}].id`, ""), vendor_page_no, search_text_vendor);
        setselLocation(getValue(filtered, `[${0}].id`, ""));
        selectedItems[getValue(filtered, `[${0}].id`, "")] = {};
        // setVendorsList([]);
        // setSubVendorList([]);
        setIsLoading(false);
      } else {
        setIsLoading(false);

        // setVendorsList([]);
        // setSubVendorList([]);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------     Vendor Pagination   ----------------------------------- */

  const [vendor_page_no, setVendorPageNo] = useState<any>(1);
  const [vendor_page_limit, setVendorPageLimit] = useState(10);
  const [vendor_total_count, setVendorsTotalCount] = useState(0);

  const handleVendorPagination = (page_no: string) => {
    setVendorPageNo(page_no);
    getVendorList(selLocation, page_no, search_text_vendor);
  };

  // const getVendorList = async (locationID: string, page_no: any) => {
  // 	if (locationID) {
  // 		const urlSearchParams = new URLSearchParams(window.location.search);
  // 		const params = Object.fromEntries(urlSearchParams.entries());

  // 		let payload: any = {
  // 			page_no: page_no ? parseInt(page_no) : 1,
  // 			page_size: vendor_page_limit,
  // 			search_text: params.search_text,
  // 			location_id: locationID,
  // 			vendor_type:'SERVICING_VENDOR',
  // 			// is_default:true,
  // 			// is_active:true
  // 		};
  // 		let queryRequest = QueryRequestHelper(payload);
  // 		try {
  // 			setIsLoading1(true);
  // 			let resp = await clientGetVendor(queryRequest);
  // 			if (resp) {
  // 				setVendorsList(getValue(resp, `data.vendors`, []));
  // 				if (getValue(resp, `data.vendors[${0}].parent_id`, "")) {
  // 					getSubVendorList(
  // 						locationID,
  // 						getValue(resp, `data.vendors[${0}].parent_id`, ""),
  // 						sub_vendor_page_no
  // 					);
  // 					setVendorsTotalCount(getValue(resp, `data.pagination.total`, ""));
  // 					setselVendor(getValue(resp, `data.vendors[${0}].parent_id`, ""));
  // 					if (
  // 						getValue(
  // 							selectedItems,
  // 							`[${locationID}][${getValue(
  // 								resp,
  // 								`data.vendors[${0}].parent_id`,
  // 								""
  // 							)}].length`,
  // 							0
  // 						) === 0
  // 					) {
  // 						selectedItems[locationID][
  // 							getValue(resp, `data.vendors[${0}].parent_id`, "")
  // 						] = [];
  // 					}
  // 					setIsLoading1(false);
  // 					setTimeout(() => {
  // 						setPermissionLoading(false);
  // 					}, 100);
  // 				} else {
  // 					setIsLoading1(false);
  // 					setVendorsList([]);
  // 					setSubVendorList([]);
  // 					setVendorsTotalCount(0);
  // 					setSubVendorsTotalCount(0);
  // 					setTimeout(() => {
  // 						setPermissionLoading(false);
  // 					}, 100);
  // 				}
  // 			} else {
  // 				setIsLoading1(false);
  // 				setVendorsList([]);
  // 				setSubVendorList([]);
  // 				setVendorsTotalCount(0);
  // 				setSubVendorsTotalCount(0);
  // 				setTimeout(() => {
  // 					setPermissionLoading(false);
  // 				}, 100);
  // 			}
  // 		} catch (error) {
  // 			setIsLoading1(false);
  // 			setVendorsList([]);
  // 			setVendorsTotalCount(0);
  // 			setSubVendorsTotalCount(0);
  // 			setSubVendorList([]);
  // 		}
  // 	}
  // };

  const getVendorList = async (locationID: string, page_no: any, search_text: string) => {
    if (locationID) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let payload: any = {
        page_no: page_no ? parseInt(page_no) : 1,
        page_size: vendor_page_limit,
        search_text: search_text,
        location_id: locationID,
        vendor_type: "SERVICING_VENDOR",
        // Remove the vendor_type filter to get all vendors
        // is_active: true
      };
      let queryRequest = QueryRequestHelper(payload);
      try {
        setIsLoading1(true);
        let resp = await clientGetVendor(queryRequest);
        if (resp) {
          setVendorsList(getValue(resp, `data.vendors`, []));
          setVendorsTotalCount(getValue(resp, `data.pagination.total`, ""));
          setIsLoading1(false);
          setTimeout(() => {
            setPermissionLoading(false);
          }, 100);
        } else {
          setIsLoading1(false);
          setVendorsList([]);
          setVendorsTotalCount(0);
          setTimeout(() => {
            setPermissionLoading(false);
          }, 100);
        }
      } catch (error) {
        setIsLoading1(false);
        setVendorsList([]);
        setVendorsTotalCount(0);
      }
    }
  };
  const [sub_vendor_page_no, setSubVendorPageNo] = useState<any>(1);
  const [sub_vendor_page_limit, setSubVendorPageLimit] = useState(10);
  const [sub_vendor_total_count, setSubVendorsTotalCount] = useState(0);

  const handleSubVendorPagination = (page_no: string) => {
    setSubVendorPageNo(page_no);
    getSubVendorList(selLocation, selVendor, sub_vendor_page_no);
  };

  const getSubVendorList = async (
    locationID: string,
    vendorID: string,
    page_no: any
  ) => {
    if (vendorID) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      let payload: any = {
        page_no: page_no ? parseInt(page_no) : 1,
        page_size: sub_vendor_page_limit,
        search_text: params.search_text,
        sort_by: params.sort_by,
        vendor_type: params.vendor_type
          ? params.vendor_type
          : "SERVICING_VENDOR",
        parent_id: vendorID,
        // is_active:true
        // is_default: true,
      };
      let queryRequest = QueryRequestHelper(payload);
      try {
        setIsLoading2(false);
        let resp = await clientGetVendor(queryRequest);

        if (resp) {
          setSubVendorList(getValue(resp, `data.vendors`, []));
          // selectedItems[locationID][vendorID] = [
          // 	getValue(resp, `data.vendors[${0}].id`, ""),
          // ];
          // selectedItems[locationID][vendorID] = [
          // 	getValue(resp, `data.vendors[${0}].id`, ""),
          // ];
          setIsLoading2(false);
          setSubVendorsTotalCount(getValue(resp, `data.pagination.total`, 0));
          setTimeout(() => {
            setPermissionLoading(false);
          }, 100);
        } else {
          setIsLoading2(false);
          setTimeout(() => {
            setPermissionLoading(false);
          }, 100);
        }
      } catch (error) {
        setIsLoading2(false);
      }
    }
  };

  // const handleSubmit = async () => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
  // 	try {
  // 		setSubmitLoading(true);
  // 		if (
  // 			Object.keys(selectedItems).length > 0 &&
  // 			getValue(selectedIDs, `length`, 0) > 0
  // 		) {
  // 			// payload object
  // 			let payload = {
  // 				checkpoints: selectedIDs.map((item: any) => ({
  // 					id: parseInt(item),
  // 					locations: Object.entries(selectedItems).map((loc: any, _index) => {
  // 						let vendor: any = Object.entries(loc[1]).map((item) => item[1]);
  // 						let allVendors = [].concat(...vendor);
  // 						return {
  // 							id: loc[0],
  // 							vendors: allVendors,
  // 						};
  // 					}),
  // 				})),
  // 				month: parseInt(month),
  // 				year: parseInt(year),
  // 			};
  // 			// removing vendor ids from locations to maintain only subvendorIDs In Payload
  // 			let mainArray: any = [];
  // 			getValue(payload, `checkpoints`, []).map((item: object) => {
  // 				return getValue(item, `locations`, []).filter((item1: object) => {
  // 					if (getValue(item1, `vendors.length`, 0) > 0)
  // 						return mainArray.push(item1);
  // 				});
  // 			});
  // 			// removing if any duplicate entries presented in mainarray
  // 			var clean = mainArray.filter(
  // 				(arr: any, index: number, self: any) =>
  // 					index === self.findIndex((t: any) => t.id === arr.id)
  // 			);

  // 			// request payload
  // 			let obj = {
  // 				checkpoints: selectedIDs.map((item: string) => ({
  // 					id: parseInt(item),
  // 					locations: clean,
  // 				})),
  // 				month: parseInt(month),
  // 				year: parseInt(year),
  // 			};
  // 			//  API calling....
  // 			if (selectedIDs && month && year) {
  // 				let resp = await assignCheckpointReleaseVendor(obj);
  // 				if (resp) {
  // 					setSubmitLoading(false);
  // 					toast.success(getValue(resp, `message`, ""));
  // 					navigate(`/repository/checkpoint/master`);
  // 				} else {
  // 					setSubmitLoading(false);
  // 				}
  // 			} else {
  // 				setSubmitLoading(false);
  // 				toast.error("All fields are mandatory");
  // 			}
  // 		} else {
  // 			setSubmitLoading(false);
  // 			toast.error("All fields are mandatory");
  // 		}
  // 	} catch (error) {
  // 		setSubmitLoading(false);
  // 	}
  // };

  const handleSubmit = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("checkpoint_id[]");
    try {
      setSubmitLoading(true);
      if (
        Object.keys(selectedItems).length > 0 &&
        getValue(selectedIDs, `length`, 0) > 0
      ) {

        const filteredLocations = Object.entries(selectedItems).filter(
          ([locationId, vendors]) => (vendors as any[]).length > 0
      );
      
        let payload = {
          checkpoints: selectedIDs.map((item: any) => ({
            id: parseInt(item),
            // locations: Object.entries(selectedItems).map(
            //   ([locationId, vendors]) => ({
            //     id: locationId,
            //     vendors: vendors,
            //   })
            // ),
            locations: filteredLocations.map(([locationId, vendors]) => ({
              id: locationId,
              vendors: vendors, // vendors is now correctly inferred as Vendor[]
          })),

          })),
          month: parseInt(month),
          year: parseInt(year),
        };

        if (selectedIDs && month && year) {
          let resp = await assignCheckpointReleaseVendor(payload);
          if (resp) {
            setSubmitLoading(false);
            toast.success(getValue(resp, `message`, ""));
            navigate(`/repository/checkpoint/master?${allParams()}`);
          } else {
            setSubmitLoading(false);
          }
        } else {
          setSubmitLoading(false);
          toast.error("All fields are mandatory");
        }
      } else {
        setSubmitLoading(false);
        toast.error("All fields are mandatory");
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                       Check box onchange section                           */
  /* -------------------------------------------------------------------------- */
  // location ids
  let locationIDs = Object.keys(selectedItems);
  const [selLocation, setselLocation] = useState("");
  const [selVendor, setselVendor] = useState("");

  const handleCheckLocation = (e: any, id: string) => {
    e.preventDefault();
    setSubVendorPageNo(1);
    setVendorPageNo(1);
    getVendorList(id, 1, "");
    setselLocation(id);
    let filtered = Object.keys(selectedItems).filter(
      (item: string) => item !== id
    );
	for (let key of filtered) {
		delete selectedItems[key];
	}

    // if (Object.keys(selectedItems).includes(id)) {
    //   delete selectedItems[id];
    //   setSelectedItems({ ...selectedItems });
    // } else {
    //   //   selectedItems[id] = {};
    //   //   setSelectedItems({ ...selectedItems });
    // }
    //************** old working **************//
    // if (Object.keys(selectedItems).includes(id)) {
    // 	delete selectedItems[id];
    // 	setSelectedItems({ ...selectedItems });
    // } else {
    // 	selectedItems[id] = {};
    // 	setSelectedItems({ ...selectedItems });
    // }
  };
  const handleRemoveLocation = (id: string) => {
    getVendorList(id, vendor_page_no, search_text_vendor);
    setselLocation(id);
    if (Object.keys(selectedItems).includes(id)) {
      delete selectedItems[id];
      setSelectedItems({ ...selectedItems });
    }
  };
  // const handleCheckVendors = (id: string) => {
  // 	setselVendor(id);
  // 	getSubVendorList(selLocation, id, sub_vendor_page_no);
  // 	if (
  // 		Object.keys(selectedItems[selLocation]).length > 0 &&
  // 		Object.keys(selectedItems[selLocation]).includes(id)
  // 	) {
  // 		// delete selectedItems[selLocation][id];
  // 		// setSelectedItems({ ...selectedItems });
  // 	} else {
  // 		selectedItems[selLocation][id] = [];
  // 		setSelectedItems({ ...selectedItems });
  // 	}
  // };

  const handleCheckVendors = (id: string) => {
    let currentSelectedVendors = getValue(
      selectedItems,
      `[${selLocation}]`,
      []
    );

    // Ensure currentSelectedVendors is an array
    if (!Array.isArray(currentSelectedVendors)) {
      currentSelectedVendors = Object.keys(currentSelectedVendors);
    }

    let updatedSelectedVendors;
    if (currentSelectedVendors.includes(id)) {
      updatedSelectedVendors = currentSelectedVendors.filter(
        (vendorId: string) => vendorId !== id
      );
    } else {
      updatedSelectedVendors = [...currentSelectedVendors, id];
    }

    setSelectedItems({
      ...selectedItems,
      [selLocation]: updatedSelectedVendors,
    });
  };

  const handleCheckSubVendors = (id: string) => {
    if (
      getValue(selectedItems, `[${selLocation}][${selVendor}].length`, 0) > 0 &&
      selectedItems[selLocation][selVendor].includes(id)
    ) {
      let filtered = selectedItems[selLocation][selVendor].filter(
        (item: string) => item !== id
      );
      selectedItems[selLocation][selVendor] = filtered;
      setSelectedItems({ ...selectedItems });
    } else {
      selectedItems[selLocation][selVendor].push(id);
      setSelectedItems({ ...selectedItems });
    }
  };
  const [permissionLoading, setPermissionLoading] = useState(true);
  let lengthOfObj: any = Object.keys(selectedItems);
  let arrOfObj: any = Object.entries(selectedItems);
  let selectedSubVendorsRuntime: any = [];
  for (let i = 0; i < getValue(lengthOfObj, `length`, 0); i++) {
    let twoDim: any = Object.values(arrOfObj[i][1]);
    let final = [].concat(...twoDim);
    let key = arrOfObj[i][0];
    selectedSubVendorsRuntime.push({ [key]: final });
  }

  /* -------------------------------------------------------------------------- */
  /*                        Location Search section                             */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
  };

  const handleChangeSearch = async (e: any) => {
    if (e.target.value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      setSearchInput(e.target.value);
      getLocations(location_page_no, e.target.value);
    } else {
      setSearchInput(e.target.value);
      // getLocations(location_page_no,e.target.value);
      if (!e.target.value) {
        // getData();
        getLocations(location_page_no, "");
      }
    }
  };

    /* -------------------------------------------------------------------------- */
  /*                        Location Search section                             */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextboxVendor, setShowSearchTextboxVendor] = useState(false);
  const [search_text_vendor, setSearchInputVendor] = useState<any>("");

  const toggleSearchVendor = () => {
    setShowSearchTextboxVendor((prevState) => !prevState);
  };
  const toggleSearchCloseVendor = () => {
    setSearchInputVendor("");
    toggleSearchVendor();
  };

  const handleChangeSearchVendor = async (e: any) => {
    if (e.target.value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      setSearchInputVendor(e.target.value);
      getVendorList(selLocation, vendor_page_no, e.target.value);
    } else {
      setSearchInputVendor(e.target.value);
      // getLocations(location_page_no,e.target.value);
      if (!e.target.value) {
        // getData();
        getVendorList(selLocation, vendor_page_no, e.target.value);
      }
    }
  };

  return (
    <>
      <Layout>
        {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "repository_checkpoint_vendor_checkpoints"
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            <section className="inner-page-navigation-with-back-cta-buttons position-relative">
              <div className="container-fluid  d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center mt-3 ms-3">
                  <NavLink to={`/repository/checkpoint/master?${allParams()}`}>
                    <img
                      src="/images/back-link.svg"
                      className="img-fluid"
                      height={24}
                      width={24}
                    />
                  </NavLink>
                  <p className="inner-page-navigation-text">
                    Release Checkpoints
                  </p>
                </div>
                {/* <div>
							{activeTab === 2 && (
								<button
									className="ascent-button ascent-button--primary"
									onClick={() => setActiveTab(1)}
								>
									Back
								</button>
							)}
							{activeTab === 1 ? (
								<button
									className="ascent-button ascent-button--header-buttons ascent-button--primary"
									onClick={() => setActiveTab(activeTab == 1 ? 2 : 1)}
								>
									Next
								</button>
							) : submitLoading ? (
								<button className="ascent-button ascent-button--header-buttons ascent-button--primary">
									Please wait...
								</button>
							) : (
								<button
									className="ascent-button ascent-button--header-buttons ascent-button--primary"
									onClick={handleSubmit}
								>
									Release
								</button>
							)}
						</div> */}
              </div>
              <div className="release-sub-header d-flex align-center justify-content-between">
                <div className="release-sub-header-container text-center">
                  <img
                    src="/images/uploaded-details/engineering.svg"
                    className="img-fluid"
                  />
                  <p className="release-sub-header-container-text release-sub-header-container-text--red">
                    Select Vendor
                  </p>
                </div>
                <div className="release-sub-header-container text-center">
                  <img
                    src="/images/uploaded-details/date.svg"
                    className="img-fluid"
                  />
                  <p className="release-sub-header-container-text">
                    Select Timeline
                  </p>
                </div>
              </div>
            </section>
            <div className="release-checkpoint  d-flex justify-content-between align-items-center">
              <h4>
                {/* Selected 20 */}
                Checkpoints
              </h4>
              {getValue(props, `permissions`, []).includes("update") && (
                <div>
                  {activeTab === 2 && (
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--primary"
                      onClick={() => setActiveTab(1)}
                    >
                      Back
                    </button>
                  )}
                  {activeTab === 1 ? (
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                      onClick={() => setActiveTab(activeTab == 1 ? 2 : 1)}
                    >
                      Next
                    </button>
                  ) : submitLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                      Please wait...
                    </button>
                  ) : (
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                      onClick={handleSubmit}
                    >
                      Release
                    </button>
                  )}
                </div>
              )}
            </div>
            {activeTab === 1 ? (
              <div>
                <div className="map-vendor-wrapper w-100">
                  <div className="map-vendor__details d-flex align-items-flex-start m-0">
                    {/* Location */}
                    <div className="map-vendor__check">
                      <div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
                        <h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
                          Location
                        </h5>
                        <div className="form-group d-flex align-iems-center m-0">
                          <StringSearch
                            searchInput={search_text}
                            showSearchTextbox={showSearchTextbox}
                            toggleSearch={toggleSearch}
                            toggleSearchClose={toggleSearchClose}
                            handleChangeSearch={handleChangeSearch}
                            label="label"
                            id="id"
                          />
                        </div>
                      </div>
                      <div className="map-vendor__checklist my-3">
                        {isLoading || !props.permissionAPITriggered ? (
                          <Loader />
                        ) : getValue(locationList, `length`, 0) > 0 ? (
                          locationList.map((searchObj, index) => {
                            let selected = getValue(
                              selectedItems,
                              `[${getValue(searchObj, `id`, "")}]`,
                              {}
                            );

                            let findCont =
                              getValue(selectedSubVendorsRuntime, `length`, 0) >
                                0 &&
                              selectedSubVendorsRuntime.filter(
                                (item: any) =>
                                  item[getValue(searchObj, `id`, "")]
                              );

                            let count: any =
                              getValue(findCont, `length`, 0) > 0 &&
                              findCont[0][getValue(searchObj, `id`, "")];

                            return (
                              <>
                                <div
                                  className={`release-details d-flex justify-content-between ${
                                    locationIDs.includes(
                                      getValue(searchObj, `id`, "")
                                    )
                                      ? "active"
                                      : ""
                                  } 
															${selLocation === getValue(searchObj, `id`, "") ? "background_selected" : ""}
															`}
                                >
                                  <div
                                    className={`justify-content-between d-flex`}
                                    onClick={(e) =>
                                      handleCheckLocation(
                                        e,
                                        getValue(searchObj, `id`, "")
                                      )
                                    }
                                  >
                                    <label
                                      className={`position-relative form-group d-flex align-items-center cursor-pointer mb-0`}
                                      htmlFor={`location-${index}-x`}
                                      key={`location-${index}-x`}
                                    >
                                      <div className="cursor-pointer">
                                        <div>
                                          <input
                                            type="radio"
                                            className="new-radio"
                                            id={`location-${index}-x`}
                                            checked={
                                              selLocation ===
                                              getValue(searchObj, `id`, "")
                                                ? true
                                                : false
                                            }
                                            onChange={(e) =>
                                              handleCheckLocation(
                                                e,
                                                getValue(searchObj, `id`, "")
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="mx-3 cursor-pointer release-details-text">
                                        <p className="release-details-text_location">
                                          {" "}
                                          {getValue(
                                            searchObj,
                                            `location_name`,
                                            ""
                                          )}
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center release-details-text_vendor_count">
                                          <div>
                                            {getValue(count, `length`, 0)}{" "}
                                            vendors selected{" "}
                                          </div>
                                          {getValue(count, `length`, 0) > 0 ? (
                                            <img
                                              src="/images/close-red.svg"
                                              className="cursor-pointer"
                                              width={20}
                                              height={20}
                                              onClick={() =>
                                                handleRemoveLocation(
                                                  getValue(searchObj, `id`, "")
                                                )
                                              }
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                  {/* <div>
																<label
																	className={`position-relative form-group d-flex align-items-center cursor-pointer mb-0`}
																	htmlFor={`location-${index}-y`}
																	key={`location-${index}-y`}
																>
																	<div>
																		<input
																			type="checkbox"
																			className="default-checkbox"
																			id={`location-${index}-y`}
																			checked={
																				locationIDs.includes(
																					getValue(searchObj, `id`, "")
																				)
																					? true
																					: false
																			}
																			onChange={() =>
																				handleCheckLocation(
																					getValue(searchObj, `id`, "")
																				)
																			}
																		/>
																		<div className="custom-checkbox--bg-red">
																			<img
																				src="/images/uploaded-details/tick.svg"
																				className="img-fluid uploaded-tick"
																			/>
																		</div>
																	</div>
																</label>
															</div> */}
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <>
                            {Object.keys(params).length !== 0 ? (
                              <>
                                <Notfound />
                              </>
                            ) : (
                              <Notfound />
                            )}
                          </>
                        )}
                        {location_total_count > 10 ? (
                          <PaginationPage
                            totalCount={location_total_count}
                            limit={location_page_limit}
                            pageNumber={location_page_no}
                            handleChangePagination={handleLocationPagination}
                            showLimit={"false"}
                            // handleChangeLimit={handleChangeLimit}
                          />
                        ) : (
                          <p className="show-rows-count mt-3 d-flex">
                            Total Count:&nbsp;&nbsp;{" "}
                            <p style={{ color: "rgb(13, 110, 253)" }}>
                              {location_total_count}
                            </p>
                          </p>
                        )}
                      </div>
                    </div>
                    {/* Vendor */}
                    <div className="map-vendor__check d-none">
                      <div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
                        <h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
                          Vendor Name
                        </h5>
                        <div className="form-group d-flex align-iems-center m-0">
                          <StringSearch
                            searchInput={search_text_vendor}
                            showSearchTextbox={showSearchTextboxVendor}
                            toggleSearch={toggleSearchVendor}
                            toggleSearchClose={toggleSearchCloseVendor}
                            handleChangeSearch={handleChangeSearchVendor}
                            label="label"
                            id="id"
                          />
                        </div>
                      </div>
                      <div className="map-vendor__checklist my-3">
                        {isLoading1 || permissionLoading ? (
                          <Loader />
                        ) : getValue(vendorsList, `length`, 0) > 0 ? (
                          vendorsList.map((searchObj, index) => {
                            let selectedVendors = Object.keys(
                              getValue(selectedItems, `[${selLocation}]`, {})
                            );
                            let selected = getValue(
                              selectedItems,
                              `[${selLocation}][${getValue(
                                searchObj,
                                `id`,
                                ""
                              )}]`,
                              []
                            );

                            return (
                              <>
                                <div
                                  className={`release-details d-flex justify-content-between ${
                                    getValue(selectedVendors, `length`, 0) >
                                      0 &&
                                    selectedVendors.includes(
                                      getValue(searchObj, `parent_id`, "")
                                    )
                                      ? "active"
                                      : ""
                                  }
															${
                                selVendor ===
                                getValue(searchObj, `parent_id`, "")
                                  ? "background_selected"
                                  : ""
                              }
															
															`}
                                >
                                  <div
                                    className="justify-content-between d-flex"
                                    onClick={() =>
                                      handleCheckVendors(
                                        getValue(searchObj, `parent_id`, "")
                                      )
                                    }
                                  >
                                    <label
                                      className={`position-relative form-group d-flex align-items-center cursor-pointer mb-0`}
                                      htmlFor={`vendor-${index}-xx`}
                                      key={`vendor-${index}-xx`}
                                    >
                                      <div className="release-details-text_vendor_name_checkbox_holder">
                                        <input
                                          type="radio"
                                          className="new-radio"
                                          id={`location-${index}-xx`}
                                          checked={
                                            selVendor ===
                                            getValue(searchObj, `parent_id`, "")
                                              ? true
                                              : false
                                          }
                                          onChange={() =>
                                            handleCheckVendors(
                                              getValue(
                                                searchObj,
                                                `parent_id`,
                                                ""
                                              )
                                            )
                                          }
                                        />
                                      </div>
                                      <div className="release-details-text mx-3 cursor-pointer">
                                        <p className="release-details-text_location">
                                          {getValue(
                                            searchObj,
                                            `vendor_name`,
                                            ""
                                          )}
                                        </p>
                                        {/* <div className="d-flex justify-content-between align-items-center">
																					<div>
																						{getValue(selected, `length`, 0)}{" "}
																						sub vendors selected{" "}
																					</div>
																					{getValue(selected, `length`, 0) >
																					0 ? (
																						<img
																							src="/images/close-red.svg"
																							className="cursor-pointer"
																							width={24}
																							height={24}
																							onClick={() =>
																								handleRemoveVendors(
																									getValue(
																										searchObj,
																										`parent_id`,
																										""
																									)
																								)
																							}
																						/>
																					) : (
																						""
																					)}
																				</div> */}
                                      </div>
                                    </label>
                                  </div>
                                  {/* <div>
																<label
																	className={`position-relative form-group d-flex align-items-center cursor-pointer mb-0`}
																	htmlFor={`location-${index}-yy`}
																	key={`location-${index}-yy`}
																>
																	<div>
																		<input
																			type="checkbox"
																			className="default-checkbox"
																			id={`location-${index}-yy`}
																			checked={
																				getValue(selectedVendors, `length`, 0) >
																					0 &&
																				selectedVendors.includes(
																					getValue(searchObj, `id`, "")
																				)
																					? true
																					: false
																			}
																			onChange={() =>
																				handleCheckVendors(
																					getValue(searchObj, `id`, "")
																				)
																			}
																		/>
																		<div className="custom-checkbox--bg-red">
																			<img
																				src="/images/uploaded-details/tick.svg"
																				className="img-fluid uploaded-tick"
																			/>
																		</div>
																	</div>
																</label>
															</div> */}
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <>
                            {Object.keys(params).length !== 0 ? (
                              <>
                                <Notfound />
                              </>
                            ) : (
                              <Notfound />
                            )}
                          </>
                        )}
                        {vendor_total_count > 10 ? (
                          <PaginationPage
                            totalCount={vendor_total_count}
                            limit={vendor_page_limit}
                            pageNumber={vendor_page_no}
                            handleChangePagination={handleVendorPagination}
                            showLimit={"false"}
                            // handleChangeLimit={handleChangeLimit}
                          />
                        ) : (
                          <p className="show-rows-count mt-3 d-flex">
                            Total Count:&nbsp;&nbsp;{" "}
                            <p style={{ color: "rgb(13, 110, 253)" }}>
                              {vendor_total_count}
                            </p>
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Vendor */}
                    <div className="map-vendor__check">
                      <div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
                        <h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
                          Vendor Name
                        </h5>
                        <div className="form-group d-flex align-iems-center m-0">
                          <StringSearch
                            searchInput={search_text_vendor}
                            showSearchTextbox={showSearchTextboxVendor}
                            toggleSearch={toggleSearchVendor}
                            toggleSearchClose={toggleSearchCloseVendor}
                            handleChangeSearch={handleChangeSearchVendor}
                            label="label"
                            id="id"
                          />
                        </div>                      </div>
                      <div className="map-vendor__checklist my-3">
                        {isLoading1 || permissionLoading ? (
                          <Loader />
                        ) : getValue(vendorsList, `length`, 0) > 0 ? (
                          vendorsList.map((searchObj, index) => {
                            let selectedVendors = getValue(
                              selectedItems,
                              `[${selLocation}]`,
                              []
                            );
                            // Ensure selectedVendors is an array
                            if (!Array.isArray(selectedVendors)) {
                              selectedVendors = Object.keys(selectedVendors);
                            }
                            let isSelected = selectedVendors.includes(
                              getValue(searchObj, `id`, "")
                            );

                            return (
                              <div
                                key={`vendor-${index}`}
                                className={`release-details d-flex justify-content-between ${
                                  isSelected ? "active" : ""
                                }`}
                              >
                                <label
                                  className="position-relative form-group d-flex align-items-center cursor-pointer mb-0"
                                  htmlFor={`vendor-${index}`}
                                >
                                  <div className="release-details-text_vendor_name_checkbox_holder">
                                    <input
                                      type="checkbox"
                                      className="default-checkbox"
                                      id={`vendor-${index}`}
                                      checked={isSelected}
                                      onChange={() =>
                                        handleCheckVendors(
                                          getValue(searchObj, `id`, "")
                                        )
                                      }
                                    />
                                    <div className="custom-checkbox--bg-red">
                                      <img
                                        src="/images/uploaded-details/tick.svg"
                                        className="img-fluid uploaded-tick"
                                      />
                                    </div>
                                  </div>
                                  <div className="release-details-text mx-3 cursor-pointer">
                                    <p className="release-details-text_location">
                                      {getValue(searchObj, `vendor_name`, "")}
                                    </p>
                                  </div>
                                </label>
                              </div>
                            );
                          })
                        ) : (
                          <>
                            {Object.keys(params).length !== 0 ? (
                              <Notfound />
                            ) : (
                              <Notfound />
                            )}
                          </>
                        )}
                      </div>
                      {vendor_total_count > 10 ? (
                        <PaginationPage
                          totalCount={vendor_total_count}
                          limit={vendor_page_limit}
                          pageNumber={vendor_page_no}
                          handleChangePagination={handleVendorPagination}
                          showLimit={"false"}
                        />
                      ) : (
                        <p className="show-rows-count mt-3 d-flex">
                          Total Count:&nbsp;&nbsp;{" "}
                          <p style={{ color: "rgb(13, 110, 253)" }}>
                            {vendor_total_count}
                          </p>
                        </p>
                      )}
                    </div>
                    {/* Sub Vendor */}
                    <div className="map-vendor__check d-none">
                      {/* {subVendorList.length > 0 && (
										<div className="form-group d-flex my-3">
											<label
												className="position-relative d-flex align-items-center cursor-pointer m-0"
												htmlFor="header-checkbox"
											>
												<div>
													<input
														type="checkbox"
														className="default-checkbox"
														id="header-checkbox"
														onChange={() =>
															handleCheckSubVendors(
																getValue(subVendorList, `[${0}].id`, "")
															)
														}
														checked={
															getValue(
																selectedItems,
																`[${selLocation}][${selVendor}].length`,
																0
															) > 0 &&
															selectedItems[selLocation][selVendor].includes(
																getValue(subVendorList, `[${0}].id`, "")
															)
														}
													/>
													<div className="custom-checkbox--bg-red">
														<img
															src="/images/uploaded-details/tick.svg"
															className="img-fluid uploaded-tick"
														/>
													</div>
												</div>
												<p className="mx-3">
													{getValue(subVendorList, `[${0}].vendor_name`, "")}
												</p>
											</label>
										</div>
									)} */}

                      <div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between">
                        <h5 className="map-vendor__search-title map-vendor__search-title--client m-0">
                          Servicing Vendor
                        </h5>
                        {/* <div className="form-group d-flex align-iems-center m-0"></div> */}
                        {/* <div className="form-group d-flex align-iems-center m-0">
											<label
												className="position-relative form-group d-flex align-items-center cursor-pointer"
												htmlFor="sub-vendor-1"
											>
												<div> */}
                        {/* <input
														type="checkbox"
														className="default-checkbox"
														id="sub-vendor-1"
														name="sub-vendor"
													/>
													<div className="custom-checkbox">
														<img
															src="/images/uploaded-details/tick.svg"
															className="img-fluid uploaded-tick"
														/>
													</div> */}
                        {/* </div>
											</label>
										</div> */}
                      </div>
                      <div className="map-vendor__checklist my-3">
                        {isLoading2 || permissionLoading ? (
                          <Loader />
                        ) : getValue(subVendorList, `length`, 0) > 0 ? (
                          subVendorList.map((searchObj, index) => {
                            let selectedSubVendors =
                              getValue(
                                selectedItems,
                                `[${selLocation}][${selVendor}].length`,
                                0
                              ) > 0 && selectedItems[selLocation][selVendor];
                            // if (index !== 0)
                            return (
                              <>
                                <label
                                  className="position-relative form-group d-flex align-items-center cursor-pointer"
                                  htmlFor={`sub-vendor1-${index}-z`}
                                  key={`sub-vendor1-${index}-z`}
                                >
                                  <div>
                                    <input
                                      type="checkbox"
                                      className="default-checkbox"
                                      id={`sub-vendor1-${index}-z`}
                                      onChange={() =>
                                        handleCheckSubVendors(
                                          getValue(searchObj, `id`, "")
                                        )
                                      }
                                      checked={
                                        getValue(
                                          selectedSubVendors,
                                          `length`,
                                          0
                                        ) > 0 &&
                                        selectedSubVendors.includes(
                                          getValue(searchObj, `id`, "")
                                        )
                                      }
                                      name="sub-vendor"
                                    />
                                    <div className="custom-checkbox--bg-red">
                                      <img
                                        src="/images/uploaded-details/tick.svg"
                                        className="img-fluid uploaded-tick"
                                      />
                                    </div>
                                  </div>
                                  <p className="mx-3">
                                    {" "}
                                    {getValue(searchObj, `vendor_name`, "")}
                                  </p>
                                </label>
                              </>
                            );
                          })
                        ) : (
                          <>
                            {Object.keys(params).length !== 0 ? (
                              <>
                                <Notfound />
                              </>
                            ) : (
                              <Notfound />
                            )}
                          </>
                        )}
                      </div>
                      {sub_vendor_total_count > 10 ? (
                        <PaginationPage
                          totalCount={sub_vendor_total_count}
                          limit={sub_vendor_page_limit}
                          pageNumber={sub_vendor_page_no}
                          handleChangePagination={handleSubVendorPagination}
                          showLimit={"false"}
                          // handleChangeLimit={handleChangeLimit}
                        />
                      ) : (
                        <p className="show-rows-count mt-3 d-flex">
                          Total Count:&nbsp;&nbsp;{" "}
                          <p style={{ color: "rgb(13, 110, 253)" }}>
                            {sub_vendor_total_count}
                          </p>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="footer-wrapper-new w-100">
                    <img
                      src="/images/footer-image.svg"
                      className="img-fluid footer-image"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="user-details-wrapper m-0">
                <div className="checkpoint-active-details-wrapper__form-wrapper">
                  <div className="checkpoint-active-details-wrapper__form-content">
                    <Row>
                      <Col md="6">
                        <div className="user-details-wrapper__form-group form-group">
                          <label className="checkpoint-active-details__label">
                            Month
                          </label>
                          <InputField
                            inputType="INPUT_REACT_SELECT"
                            placeholder="Choose Month"
                            className="users-form-control"
                            name="month"
                            id="month"
                            options={months}
                            value={months.filter(
                              (item: object) =>
                                getValue(item, `value`, "") == month
                            )}
                            onChange={(e: any) => setMonth(e.value)}
                            label="Month"
                            // validator={simpleValidator}
                          />
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="user-details-wrapper__form-group form-group">
                          <label className="checkpoint-active-details__label">
                            Year
                          </label>
                          <InputField
                            inputType="INPUT_REACT_SELECT"
                            placeholder="Choose Month"
                            className="users-form-control"
                            name="month"
                            id="month"
                            options={years}
                            value={years.filter(
                              (item: object) =>
                                getValue(item, `value`, "") == year
                            )}
                            onChange={(e: any) => setYear(e.value)}
                            label="Year"
                            // validator={simpleValidator}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </Layout>
    </>
  );
}
